import { useReducer } from 'react';
export function useForceUpdate() {
  const [forceUpdateValue, forceUpdate] = useReducer(x => x + 1, 0);
  return {
    forceUpdate,
    forceUpdateValue
  };
}